module.exports = __webpack_public_path__ + "static/media/pt-ecosentino-bathroom-days-large.dce5f9e0.png";